import { render, staticRenderFns } from "./ActivityKaraoke.vue?vue&type=template&id=6acf0122&scoped=true"
import script from "./ActivityKaraoke.vue?vue&type=script&lang=ts"
export * from "./ActivityKaraoke.vue?vue&type=script&lang=ts"
import style0 from "./ActivityKaraoke.vue?vue&type=style&index=0&id=6acf0122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acf0122",
  null
  
)

export default component.exports